import React from 'react';
import createAtomicBlockButton from '@studionand/ada-next/src/legacy/InlineToolbar/utils/createAtomicBlockButton';
import defaultServices from '@studionand/ada-next/src/legacy/AtomicToolbar/services';
import AnsprechpartnerIcon from '../../shared/icons/Ansprechpartner';
import AdaSectionDividerIcon from '../../shared/icons/AdaSectionDivider';
import MicroPageIcon from '../../shared/icons/MicroPage';
import Calendar from '../../shared/icons/Calendar';
import Pdf from '../../shared/icons/Pdf';
import Contact from '../../shared/icons/Contact';
import Spreadsheet from '../../shared/icons/Spreadsheet';
import Chart from '../../shared/icons/Chart';

const atomicBlockServices = [
  createAtomicBlockButton({
    help: 'Ansprechpartner',
    blockType: 'ansprechpartner',
    children: <AnsprechpartnerIcon fontSize="small" />,
    addCaption: false,
    entityJson: {
      type: 'ansprechpartner',
      mutability: 'IMMUTABLE',
      data: {
        ansprechpartner: null,
      },
    },
  }),
  createAtomicBlockButton({
    help: 'Seiten Referenz',
    blockType: 'page-reference',
    children: <MicroPageIcon fontSize="small" />,
    addCaption: false,
    entityJson: {
      type: 'page-reference',
      mutability: 'IMMUTABLE',
      data: {
        uuid: null,
      },
    },
  }),
  createAtomicBlockButton({
    help: 'Kalendar Button',
    blockType: 'add-to-calendar',
    children: <Calendar fontSize="small" />,
    addCaption: false,
  }),
  createAtomicBlockButton({
    help: 'PDF Button',
    blockType: 'save-to-pdf',
    children: <Pdf fontSize="small" />,
    addCaption: false,
  }),
  createAtomicBlockButton({
    help: 'Kontakt Button',
    blockType: 'event-contact',
    children: <Contact fontSize="small" />,
    addCaption: false,
  }),
  createAtomicBlockButton({
    help: 'Tabelle',
    blockType: 'table-editor',
    children: <Spreadsheet fontSize="small" />,
    entityJson: {
      type: 'table-editor',
      mutability: 'IMMUTABLE',
      data: {
        data: null,
      },
    },
    addCaption: true,
  }),
  createAtomicBlockButton({
    help: 'Preisgrafik',
    blockType: 'price-chart',
    children: <Chart fontSize="small" />,
    entityJson: {
      type: 'price-chart',
      mutability: 'IMMUTABLE',
      data: {
        data: null,
      },
    },
    addCaption: false,
  }),
  createAtomicBlockButton({
    help: 'Trennlinie',
    blockType: 'section',
    children: <AdaSectionDividerIcon fontSize="small" />,
    addCaption: false,
  }),
  ...defaultServices,
];

export default atomicBlockServices;
